import xhrService from "../common/xhrService";
import handleLoadEnd from "./handleLoadEnd";
import handleLoadStart from "./handleLoadStart";
import handleRequestFail from "./handleRequestFail";
import handleRequestSuccess from "./handleRequestSuccess";
const setClassScheduleInfoByClassId = (classId, reservationForm) => {
    const xhr = new XMLHttpRequest();
    xhr.onloadstart = () => {
        handleLoadStart();
    };
    xhr.onloadend = () => {
        handleLoadEnd();
    };
    xhrService(xhr, handleRequestSuccess(xhr), handleRequestFail(reservationForm), "GET", "https://q9t1xg47be.execute-api.ap-northeast-1.amazonaws.com/Prod?classId=" + classId, [{ key: "Content-Type", value: "application/json" }]);
};
export default setClassScheduleInfoByClassId;
